import React, { createContext, useContext, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import LeadForm from "@/components/LeadForm";

const QuoteCtx = createContext(null);

export function QuoteProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [config, setConfig] = useState({});

  const openQuote = (cfg = {}) => {
    setConfig(cfg);
    setOpen(true);
  };

  return (
    <QuoteCtx.Provider value={{ openQuote }}>
      {children}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-cream border-forest/20 max-w-lg" data-testid="quote-dialog">
          <DialogHeader>
            <DialogTitle className="font-display text-3xl text-forest">
              {config.title || "Request a Wholesale Quote"}
            </DialogTitle>
            <DialogDescription className="text-sm text-muted-foreground">
              {config.subtitle || "Share your requirement and our team will get back within 24 hours."}
            </DialogDescription>
          </DialogHeader>
          <LeadForm
            type={config.type || "quote"}
            fields={config.fields || ["name", "phone", "email", "business_type", "product", "quantity", "message"]}
            submitLabel={config.submitLabel || "Get My Quote"}
            onSuccess={() => setTimeout(() => setOpen(false), 2200)}
          />
        </DialogContent>
      </Dialog>
    </QuoteCtx.Provider>
  );
}

export const useQuote = () => useContext(QuoteCtx);
